import { z } from "zod/mini"

import { WidgetKeySchema } from "../common/widgetKey"
import { WidgetContentSchema } from "./widget"

export const DocumentContentSchema = z.record(WidgetKeySchema, WidgetContentSchema)

export type DocumentContent = z.infer<typeof DocumentContentSchema>
